export const getPointer = searchQuery => {
  return searchQuery?.pointer ?? 'current';
};
